import { createContext, useState } from 'react';
import { MainLayout, Layout as LayoutGrid, Content, ErrorOverlay, Footer } from '@servahealth/serva-ui-kit';
import { Outlet, useNavigate } from 'react-router-dom';
import parse from 'html-react-parser';
import ReportSideNav from './ReportSideNav';
import useAuth from '../../Hooks/useAuth';
import AppHeader from '../Shared/AppHeader';
import buildInfo from '../../buildInfo';

export const AppShellContext = createContext();

function dayOfYear(date){
    return (Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()) - Date.UTC(date.getFullYear(), 0, 0)) / 24 / 60 / 60 / 1000;
}
const buildYear = new Date(buildInfo.buildDate).getFullYear();
const buildDOY = dayOfYear(new Date(buildInfo.buildDate));
/**
 * ServaCore main layout for authenticated users
 * @param {*} props 
 * @returns 
 */
const AppShell = (props) => {

	const { logout, brand } = useAuth();

	const nav = useNavigate();

	// MainLayout expects seconds until the inactivity warning modal appears.
	// After the warning opens, the UI kit counts down for the same duration again before logout.
	const idleWarningDelaySeconds = (brand?.idleTimeoutOverride ?? 7) * 60;

	// layout state
	const [context, setContext] = useState({});

	// side menu
	const [collapsed, setCollapsed] = useState(false);

	const contentStyle = {
		padding: 10,
		paddingTop: 10,
		maxWidth: 2200,
	};

	// project CSS style override
	const customStyle = !!brand?.executionStyle && brand.executionStyle !== '' ? parse('<style>' + brand.executionStyle + '</style>') : <></>;

	return (
		<MainLayout
			timeout={idleWarningDelaySeconds}
			configProps={{
				theme:
					{
						token: {
							colorBgBase: '',
							colorPrimary: '#009ee2',
							borderRadius: 10,
							padding: 10,
							margin: 10,
							fontSize: 13,
							marginXXL: 36,
							marginXL: 24,
							marginLG: 16,
							marginMD: 12,
							marginSM: 8,
							marginXS: 5,
							marginXXS: 2
						},
						components: {
							Layout: {
								bodyBg: '#B4C2CA',
								lightSiderBg: 'rgb(255,255,255)'
							}
						},
					}
			}}
			onTimeout={async () => {
				await logout('Last Session Ended Due To: Inactivity Timeout');
				nav('/');
			}}
		>
			{customStyle}
			<AppShellContext.Provider value={{ context, setContext }}>
				<ErrorOverlay>
					<AppHeader />
				</ErrorOverlay>
				<LayoutGrid className='AppBody'>
					<ErrorOverlay>
						<ReportSideNav
							collapsed={collapsed} 
							setCollapsed={setCollapsed} 
						/>
					</ErrorOverlay>
					<LayoutGrid className='WorkspaceShell'>
						<ErrorOverlay>
							<Content className='WorkspaceScrollBody' style={contentStyle}>
								<Outlet />
								<div className='footer-wrap'>
									<Footer className='py-0 footer' startYear={'2024'} isAdmin={false} version={' B:' + buildInfo.buildVersion + ' D:' + buildYear + '-' + buildDOY}></Footer>
								</div>
							</Content>
						</ErrorOverlay>
					</LayoutGrid>
				</LayoutGrid>
			</AppShellContext.Provider>
		</MainLayout>
	);
};

export default AppShell;
